<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka" :selectorPermissions="selectorPermissions" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Varnostna zaščita
          </p>
          <p style="padding-top: 20px" v-if="seznamNosilnihPrikljuckov.length > 1 && activetab !== 't1'">
            Izbrani priključek
            <IzbirnikPrikljuckaSelect
              style-class="izbirnik-prikljuckov"
              @novIzbranPrikljucek="izbranPrikljucek = $event"
              :izbranPrikljucek="izbranPrikljucek"
              :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
            />
          </p>
          <p style="padding-top: 20px" v-if="prikaziIzbirnikPrikljucklovZaScit">
            Izbrani priključek
            <IzbirnikPrikljuckaSelect
              style-class="izbirnik-prikljuckov"
              @novIzbranPrikljucek="izbranPrikljucekScit = $event"
              :izbranPrikljucek="izbranPrikljucekScit"
              :seznamPrikljuckovGrupirano="seznamZaIzbirnikPrikljuckovScit"
            />
          </p>
          <div style="padding-top: 15px">
            <el-tabs
              type="border-card"
              @tab-click="HandleTabClick"
              :value="tabsValue"
              v-loading="shields === null || shields.terminationPointsForOrder === null || loadingPrikljucki"
              style="min-height: 400px;"
              element-loading-text="Pripravljamo podatke. Prosimo, počakajte."
            >
              <el-tab-pane
                label="T-2 Ščit"
                name="t1"
                ref="t1"
              >
                <div v-if="activetab === 't1'">
                  <NarociScit
                    v-if="shields !== null && shields.terminationPointsForOrder !== null"
                    :idTerminationPoint="izbranPrikljucekScitComputed"
                    :idCustomer="Number.parseInt(izbranaStranka)"
                  />
                </div>
              </el-tab-pane>
              <el-tab-pane label="Antivirusna zaščita" name="t2" ref="t2" v-if="seznamNosilnihPrikljuckov.length !== 0">
                <div v-if="activetab === 't2'">
                  <ZascitaVarnostna
                    :izbranPrikljucek="izbranPrikljucek"
                    :seznamNarocenaZascita="seznamNarocenaZascita"
                    :seznamVkloplenaZascita="seznamVkloplenaZascita"
                  />
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

<!--          <div v-if="seznamNosilnihPrikljuckov.length === 0 && !pridobivanjePodatkov">-->
<!--            <div class="obvestilo-prazen-seznam">-->
<!--              <p>-->
<!--                Nimate priključka, ki bi omogočil naročilo.-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
import {StoritevVrstaEnum} from '../../../../assets/js/Enum/StoritevVrstaEnum.js'
import ZascitaVarnostna from '../../../Dashboard/Views/Naroci/NarociInternet/ZascitaVarnostna.vue'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {Checkbox, Button, Option, Select, Pagination, TabPane, Tabs} from 'element-ui'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {SeznamVrednosti} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SeznamVrednosti'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import NarociScit from './NarociVarnostnaZascita/NarociScit.vue'
import Shields from '../../../../assets/js/T2Shield/Shields'

export default {
  name: 'VarnostnaZascita',
  mixins: [
    SirinaOkna,
    StoritevVrstaEnum,
    PridobivanjeVklopljenoNaroceno,
    GetPodatkiIzbirnika,
    StringConverter,
    SeznamVrednosti
  ],
  data () {
    return {
      activetab: 't1',
      clientAgent: null,
      nalaganjePaketov: false,
      seznamNarocenaZascita: [],
      seznamVkloplenaZascita: [],
      izbranPrikljucek: null,
      izbranaStranka: '',
      podatkiStranke: [],
      izbranSap: '',
      seznamNosilnihPrikljuckov: [],
      tabsValue: 't1',
      nalaganjeVsebine: true,
      selectorPermissions: ['STRANKE'],
      pridobivanjePodatkov: true,
      izbranaStrankaInfo: null,
      seznamPrikljuckovGrupirano: [],
      shields: null,
      izbranPrikljucekScit: null,
      loadingPrikljucki: true
    }
  },
  computed: {
    izbranPrikljucekScitComputed () {
      if (
        this.activetab === 't1' &&
        this.shields !== null &&
        this.shields.terminationPointsForOrder !== null &&
        this.shields.terminationPointsForOrder.length === 1
      ) {
        return this.shields.terminationPointsForOrder[0].terminationPointId
      }
      return Number.parseInt(this.izbranPrikljucekScit)
    },
    prikaziIzbirnikPrikljucklovZaScit () {
      return this.activetab === 't1' &&
        this.shields !== null &&
        this.shields.terminationPointsForOrder !== null &&
        this.shields.terminationPointsForOrder.length > 1 &&
        this.izbranPrikljucekScit !== null
    },
    seznamZaIzbirnikPrikljuckovScit () {
      let out = [{
        label: 'Fiksni priključki',
        prikljucki: []
      }]
      if (this.shields.terminationPointsForOrder.length > 0) {
        this.shields.terminationPointsForOrder.forEach((item) => {
          out[0].prikljucki.push({
            id_prikljucek: item.terminationPointId + '',
            tip_prikljucka: 'FIX',
            podatekZaIzpisPrikljucek: item.title
          })
        })
      }
      return out
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
  },
  watch: {
    orientacijaPrikazaTabele: function (val) {
      this.prikazTabele = val
    }
  },
  components: {
    NarociScit,
    IzbirnikPrikljuckaSelect,
    'IzbirnikStranke': IzbirnikStranke,
    'ZascitaVarnostna': ZascitaVarnostna,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Pagination.name]: Pagination,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  methods: {
    async GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.loadingPrikljucki = true
        this.izbranPrikljucek = null
        this.izbranaStrankaInfo = null
        this.izbranaStranka = podatkiStranke.id_stranka
        this.shields = Shields.getInstance(Number.parseInt(this.izbranaStranka))
        this.GetPrikljuckiDovoljenja(this.izbranaStranka)
        this.izbranaStrankaInfo = podatkiStranke
        try {
          await this.shields.loadShields(true)
          if (this.shields.terminationPointsForOrder.length > 0) {
            this.izbranPrikljucekScit = this.shields.terminationPointsForOrder[0].terminationPointId + ''
          }
        } catch (e) {
          e.duration = 0
          this.ShowErrorMessage(e)
        }
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissionId=PRIKLJUCKI']
        param.push('filter[tip_prikljucka]=FIX')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamNosilnihPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.permission.additionalData
      )
      this.loadingPrikljucki = false
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamNosilnihPrikljuckov = list
      this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      this.seznamPrikljuckovGrupirano = groupedList
      this.pridobivanjePodatkov = false
    },
    ErrPrikljuckiDovoljenja (podatki) {
      this.loadingPrikljucki = false
      this.ShowWarningMessage(podatki)
    },
    HandleTabClick (tab) {
      this.activetab = ''
      this.activetab = tab.name
    }
  }
}
</script>
<style scoped src="../../../../../static/css/MojT-2/T2Klub/T2Klub.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/VarnostnaZascita.vue